import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useBackdropContext } from '../../../../context/backdrop';
import { useErrors } from '../../../../hooks/errors/use-errors';
import { useLogoutLavva } from '../../../../modules/settings/profile/hooks/use-logout-lavva';
import { useHttpClient } from '../../../../utils/clients/rest-client';
import { toastSuccess } from '../../../../utils/toast';
import { UsersDeleteData } from '../../types/openapi/openapi-types';

export const useDeleteUser = () => {
  const { t } = useTranslation('profile');
  const httpClient = useHttpClient();
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();
  const { handleLogoutLavva } = useLogoutLavva();
  const { handleRestErrors } = useErrors();

  return useMutation<AxiosResponse<UsersDeleteData>, AxiosError<void>, void>(
    ['user-delete'],
    async () => {
      turnOnBackdrop();
      return await httpClient.users.usersDelete();
    },
    {
      onSuccess: () => {
        turnOffBackdrop();
        toastSuccess({ content: t('deleteProfile.deleteSuccessfull') });
        handleLogoutLavva();
      },
      onError: (error) => {
        turnOffBackdrop();
        handleRestErrors(error);
      },
    },
  );
};
